import gql from 'graphql-tag'

export const listenDeviceStatus = gql`
	subscription listenDevicesUpdates($hardwareId: ID) {
		listenDeviceStatuses(hardwareId: $hardwareId) {
			id
			sender
			payload
		}
	}
`


export const establishChannelConnection = gql`
	mutation establishChannelConnection($hardwareId: ID!) {
		establishChannelConnection(hardwareId: $hardwareId) {
			endpointList {
				protocol
				endpoint
			}
			iceServerList {
				username
				uris
				ttl
				password
			}
			channelARN
		}
	}
`
